module.exports = __webpack_public_path__ + "static/media/digital-work6.3d5c78c9.jpg";